module.exports = __webpack_public_path__ + "img/a3.81709bcb.jpg";